import activationCode from './activationCode';
import createAgcoId from './createAgcoId';
import password from './password';
import personalDetails from './personalDetails';
import address from './address';
import phone from './phone';
import confirmation from './confirmation';
import consentFinish from './consent';
import businessInformation from './businessInformation';

export default {
  activationCode,
  createAgcoId,
  password,
  personalDetails,
  address,
  phone,
  confirmation,
  consentFinish,
  businessInformation,
};
